import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    color: "#193446",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M21.216 11.25H2.784c-.433 0-.784.336-.784.75s.351.75.784.75h18.432c.433 0 .784-.336.784-.75s-.351-.75-.784-.75" fill="currentColor"/>' }
  })
);